import { render, staticRenderFns } from "./PopupPromotion.vue?vue&type=template&id=232dd243"
import script from "./PopupPromotion.vue?vue&type=script&lang=js"
export * from "./PopupPromotion.vue?vue&type=script&lang=js"
import style0 from "./PopupPromotion.vue?vue&type=style&index=0&id=232dd243&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports